const prodConfig = (window as any)._env
const localConfig = process?.env || {}

export const runtimeConfig = {
  directoryApiToco: localConfig.REACT_APP_DIRECTORY_API_URL || prodConfig.REACT_APP_DIRECTORY_API_URL,
  apiToco: localConfig.REACT_APP_API_URL || prodConfig.REACT_APP_API_URL,
}
